import { values } from "lodash";

import untypedItems from "@data/items.json";

import type { Item, ItemsJson } from "@typings/product/item";

const items: ItemsJson = untypedItems as ItemsJson;

export default (): Item[] => {
  const gifts = values(items).filter((i) => i.category.name === "Free Gift");

  return gifts;
};
